// External libraries
import React, { useEffect } from 'react';

// Internal modules
import { features, logger } from '@/lib';
import { ForcedPassword } from './ForcedPassword';
import { ForcedPasswordless } from './ForcedPasswordless';

export const ForcedSignup = (): JSX.Element => {
  const isPasswordless = features.isActive('passwordlessForcedSignup');

  useEffect(() => {
    logger.info(
      isPasswordless
        ? 'rendering_passwordless_forced_sign_up_flow'
        : 'rendering_forced_sign_up_flow',
    );
  }, []);

  if (isPasswordless) {
    return <ForcedPasswordless />;
  }

  return <ForcedPassword />;
};
